import './FilterTag.scss';
import React from 'react';
import { Typography } from '@dataartdev/uikit/Typography';
import { cn } from '../../utils/bem';

interface Props {
  label: string;
  active: boolean;
  tagHandler: (value: string) => void;
}

const cnFilterTag = cn('FilterTag');

export const FilterTag: React.FC<Props> = ({
  label,
  active = false,
  tagHandler,
}) => {
  return (
    <button
      className={cnFilterTag()}
      onClick={() => tagHandler(label.toLowerCase())}
      data-active={active}
    >
      <Typography.Text as="span" size="xs" transform="uppercase" weight="bold">
        {label}
      </Typography.Text>
    </button>
  );
};
